// Timeout & Duration constants (milliseconds)
export const INACTIVITY_TIMEOUT = 60_000;
export const DEFAULT_INACTIVITY_TIMEOUT = 30_000;
export const TOAST_DISPLAY_DURATION = 2_000;
export const SUCCESS_MESSAGE_DURATION = 3_000;
export const TOAST_FADE_DURATION = 300;
export const QUOTE_ROTATION_INTERVAL = 60_000;
export const REDIRECT_COUNTDOWN_SECONDS = 5;

// Validation — field lengths
export const MAX_USERNAME_LENGTH = 20;
export const MAX_NAME_LENGTH = 50;
export const MAX_SUBGOAL_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 500;
// Same as Todo.DESCRIPTION_MAX_LENGTH on the backend; counted on the saved markdown
export const MAX_TODO_DESCRIPTION_LENGTH = 3_000;
export const MAX_SUGGESTION_TITLE_LENGTH = 200;
export const MAX_SUGGESTION_MESSAGE_LENGTH = 2_000;
export const MIN_SUGGESTION_MESSAGE_LENGTH = 20;
export const MAX_GOAL_DESCRIPTION_DISPLAY = 120;

// Layout
export const MOBILE_BREAKPOINT = 768;
export const TOAST_Z_INDEX = 10_000;

// Date defaults
export const DEFAULT_DUE_DAYS = 30;

// HTTP status codes
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;
